/**
 * This event is fired when the user has consent and services are executed (but in `document.readyState === "interactive"` state).
 *
 * For non-interactive state use the `opt-in` and `opt-out` events.
 */ export const APPLY_INTERACTIVE_EVENT = "RCB/Apply/Interactive";
